import Axios from "axios";
import { SETTINGS } from "../../../properties/ApiProps";

export const AuthorshipRepository = {
  saveAuthorshipData: (vacId, data) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/${vacId}/authorships`,
      method: "POST",
      data: data,
    });
  },
  getAuthorshipData: (vacId) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/${vacId}/authorships`,
      method: "GET",
    });
  },
  getAllTypes: (gradingSchemaId) => {
    return Axios({
      url: `${SETTINGS.API_URL}authorshipTypes`,
      method: "GET",
      params: { gradingSchemaId: gradingSchemaId },
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  getAllRoles: (gradingSchemaId) => {
    return Axios({
      url: `${SETTINGS.API_URL}authorshipRoles`,
      method: "GET",
      params: { gradingSchemaId: gradingSchemaId },
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  updatePoints: (id, points) => {
    return Axios({
      url: `${SETTINGS.API_URL}authorship/${id}/points`,
      params: { points: points },
      method: "PUT",
    });
  },

  unlockPoints: (id) => {
    return Axios({
      url: `${SETTINGS.API_URL}authorship/${id}/unlockPoints`,
      method: "PUT",
    });
  },

  setComment: (id, comment) => {
    return Axios({
      url: `${SETTINGS.API_URL}authorship/${id}/comment`,
      params: { comment: comment },
      method: "PUT",
    });
  },
};
